import { ServiceCode } from '@common/enums';
import { OphthalmologyFilePlacement } from '@common/validation/customControls/ophthalmology';

export function getPlacementLabelsForService(serviceCode: ServiceCode): PlacementLabel[] | null {
    let placementLabels: PlacementLabel[] | null;

    switch (serviceCode) {
        case ServiceCode.TFO:
            return [
                { key: OphthalmologyFilePlacement.od, label: 'OD' },
                { key: OphthalmologyFilePlacement.os, label: 'OS' },
                { key: OphthalmologyFilePlacement.aanvullend, label: 'Aanvullend' },
            ];
        case ServiceCode.TOO:
            return [
                { key: OphthalmologyFilePlacement.verwijsbrief, label: 'Verwijsbrief' },
                { key: OphthalmologyFilePlacement.od, label: 'OD' },
                { key: OphthalmologyFilePlacement.os, label: 'OS' },
                { key: OphthalmologyFilePlacement.aanvullend, label: 'Aanvullend' },
            ];
        default:
            placementLabels = null;
    }

    return placementLabels;
}

export type PlacementLabel = {
    key: string;
    label: string;
};
